export const ORDER_ITEMS = "order_items";
export const FILTERS_DRAWER_KEY = "filters_drawer";
export const TAB_ORDER_KEY = "tabOrder";
